export default "__VITE_PUBLIC_ASSET__4fd1df69__"